import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class QuestionTypeApi extends NewviewOaBaseApi {

    public get ControllerName(): any {
        return 'question-type'
    }

}